import {
    ConsultantInvoicePaymentStatus,
    INVOICE_TRACKING_PAYOUT_DAYS,
} from '../InvoicingConstants';
import { StepperStatusEnum } from '../../commons/Constants';
import {
    addDaysToDate,
    ENGLISH_FORMAT,
    formatDateString,
} from '../../commons/DateUtils';

export const getInvoiceTrackingStepperDetails = (invoicePaymentStatus) => {
    const steps = [
        {
            label: ConsultantInvoicePaymentStatus.UNDER_REVIEW,
            status: StepperStatusEnum.INCOMPLETE,
        },
        {
            label: ConsultantInvoicePaymentStatus.DETAILS_VERIFIED,
            status: StepperStatusEnum.INCOMPLETE,
        },
        {
            label: ConsultantInvoicePaymentStatus.PAYMENT_INITIATED,
            status: StepperStatusEnum.INCOMPLETE,
        },
        {
            label: ConsultantInvoicePaymentStatus.PAYMENT_SUCCESSFUL,
            status: StepperStatusEnum.INCOMPLETE,
        },
    ];

    const statusIndexMap = {
        [ConsultantInvoicePaymentStatus.UNDER_REVIEW]: 0,
        [ConsultantInvoicePaymentStatus.DETAILS_VERIFIED]: 1,
        [ConsultantInvoicePaymentStatus.PAYMENT_INITIATED]: 2,
        [ConsultantInvoicePaymentStatus.PAYMENT_SUCCESSFUL]: 3,
        [ConsultantInvoicePaymentStatus.PAYMENT_FAILED]: 3,
    };

    const activeStep = !invoicePaymentStatus
        ? -1
        : statusIndexMap[invoicePaymentStatus];

    for (let i = 0; i < activeStep; i += 1) {
        steps[i].status = StepperStatusEnum.COMPLETED;
    }

    if (activeStep !== -1) {
        steps[activeStep].status = StepperStatusEnum.ACTIVE;
    }

    if (
        invoicePaymentStatus ===
        ConsultantInvoicePaymentStatus.PAYMENT_SUCCESSFUL
    ) {
        steps[3].status = StepperStatusEnum.SUCCESS;
    } else if (
        invoicePaymentStatus === ConsultantInvoicePaymentStatus.PAYMENT_FAILED
    ) {
        steps[3].label = ConsultantInvoicePaymentStatus.PAYMENT_FAILED;
        steps[3].status = StepperStatusEnum.FAILURE;
    }

    return { steps, activeStep };
};

/**
 * Get date label and isEstimatedDate flag for each step in the invoice tracking stepper
 * @param {number} stepIndex - Index of the step (0-3)
 * @param {string} stepStatus - Status of the step (INCOMPLETE, ACTIVE, COMPLETED, SUCCESS, FAILURE)
 * @param {string} paymentStatusUpdatedOn - Date when payment status was last updated
 * @param {string} invoiceSubmissionDate - Date when invoice was submitted
 *
 * @returns {object} - Object with dateLabel and isEstimatedDate flag
 */
export const getStepDateDetails = (
    stepIndex,
    stepStatus,
    paymentStatusUpdatedOn,
    invoiceSubmissionDate
) => {
    // For completed steps and active step, show the actual date
    if (
        stepStatus === StepperStatusEnum.COMPLETED ||
        stepStatus === StepperStatusEnum.ACTIVE ||
        stepStatus === StepperStatusEnum.SUCCESS ||
        stepStatus === StepperStatusEnum.FAILURE
    ) {
        return {
            dateLabel: formatDateString(paymentStatusUpdatedOn, ENGLISH_FORMAT),
            isEstimatedDate: false,
        };
    }

    // For incomplete future steps, only show estimated date for Payment Successful (index 3)
    if (stepStatus === StepperStatusEnum.INCOMPLETE && stepIndex === 3) {
        return {
            dateLabel: addDaysToDate(
                invoiceSubmissionDate,
                INVOICE_TRACKING_PAYOUT_DAYS,
                ENGLISH_FORMAT
            ),
            isEstimatedDate: true,
        };
    }

    return { dateLabel: '-', isEstimatedDate: false };
};
